import React from 'react'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite/no-important'
import { history } from '../../../../store'
import dayjs from 'dayjs'

import { colors } from '@lmc/common/constants'
import { LogSummary, ResidentPictureName } from '../../../../components/generic'
import { commonPatterns } from '../../../../utils/enhancedTestIds'

export const LogsTableItem = ({
  log,
  residentStyle,
  linkEnabled,
  testId,
  index
}) => {
  const isDeleted = log.deleted
  const redirect = (url) => history.push(`/${url}`)

  const rowId = index !== undefined ? index : 0
  const itemTestId = testId
    ? commonPatterns.row(`${testId}-summary`, rowId)
    : undefined
  const timeTestId = testId ? `${testId}-row-time-${rowId}` : undefined
  const residentTestId = testId ? `${testId}-row-resident-${rowId}` : undefined
  const logTestId = testId ? `${testId}-row-log-${rowId}` : undefined

  return (
    <div className={css(classes.wrapper)} data-testid={itemTestId}>
      <div
        className={
          !isDeleted
            ? css(classes.timeLoggedContainer)
            : css(classes.timeLoggedContainerGreyed)
        }
        data-testid={timeTestId}
      >
        {dayjs(log.timeLogged).format('DD-MM-YYYY HH:mm')}
      </div>
      <ResidentPictureName
        data={log.resident}
        isLogRemoved={log.deleted}
        onSelect={redirect}
        style={residentStyle}
        testId={residentTestId}
      />
      <LogSummary
        data={log}
        isLogRemoved={log.deleted}
        linkEnabled={linkEnabled}
        onSelect={redirect}
        testId={logTestId}
      />
    </div>
  )
}

const classes = StyleSheet.create({
  timeLoggedContainer: {
    marginRight: 12,
    paddingTop: 12,
    width: '20%'
  },
  timeLoggedContainerGreyed: {
    marginRight: 12,
    paddingTop: 12,
    width: '20%',
    color: colors.darkgrey
  },
  wrapper: {
    borderBottom: '1px solid',
    borderColor: colors.grey,
    display: 'flex',
    padding: '16px 0px'
  }
})

LogsTableItem.propTypes = {
  log: PropTypes.object.isRequired,
  role: PropTypes.string,
  residentStyle: PropTypes.object,
  linkEnabled: PropTypes.bool,
  testId: PropTypes.string,
  index: PropTypes.number
}

export default LogsTableItem
